export default "__VITE_ASSET__XUsVff2f__"